// Adds prev/next arrows to the Reviews.io Polaris review list, which reviews-carousel.css lays out as a horizontal track.
(() => {
  const ICON_PREV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg>';
  const ICON_NEXT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18l6-6-6-6"/></svg>';

  const createButton = (direction) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `rc-nav rc-nav--${direction}`;
    button.setAttribute('aria-label', direction === 'prev' ? 'Previous reviews' : 'Next reviews');
    button.innerHTML = direction === 'prev' ? ICON_PREV : ICON_NEXT;
    return button;
  };

  const updateButtons = (list, prev, next) => {
    const maxScroll = list.scrollWidth - list.clientWidth;
    prev.disabled = list.scrollLeft <= 8;
    next.disabled = list.scrollLeft >= maxScroll - 8;
  };

  // Reviews longer than the CSS line clamp get a Read more / Read less toggle
  const addReadMore = (text) => {
    let toggle = text.nextElementSibling;
    if (!toggle || !toggle.classList.contains('rc-more')) {
      toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'rc-more';
      toggle.addEventListener('click', () => {
        const expanded = text.classList.toggle('rc-expanded');
        toggle.textContent = expanded ? 'Read less' : 'Read more';
      });
      text.after(toggle);
    }

    if (text.classList.contains('rc-expanded')) return;
    // Only write when needed: text changes are DOM mutations and would re-trigger the observer
    if (toggle.textContent !== 'Read more') toggle.textContent = 'Read more';
    toggle.hidden = text.scrollHeight <= text.clientHeight + 2;
  };

  const enhance = (container) => {
    const list = container.querySelector(':scope > .R-ContentList');
    if (!list) return;

    let prev = container.querySelector(':scope > .rc-nav--prev');
    let next = container.querySelector(':scope > .rc-nav--next');

    if (!prev || !next) {
      prev = createButton('prev');
      next = createButton('next');
      container.append(prev, next);
    }

    if (list.dataset.rcBound !== 'true') {
      list.dataset.rcBound = 'true';
      const page = () => list.clientWidth * 0.9;
      prev.addEventListener('click', () => list.scrollBy({ left: -page(), behavior: 'smooth' }));
      next.addEventListener('click', () => list.scrollBy({ left: page(), behavior: 'smooth' }));
      list.addEventListener('scroll', () => updateButtons(list, prev, next), { passive: true });
      new ResizeObserver(() => {
        list.querySelectorAll('.R-ContentList__item .u-whiteSpace--prewrap').forEach(addReadMore);
        updateButtons(list, prev, next);
      }).observe(list);
    }

    // A new page of reviews was loaded: go back to the first card
    const firstItem = list.firstElementChild;
    if (firstItem && list.rcFirstItem !== firstItem) {
      list.rcFirstItem = firstItem;
      list.scrollTo({ left: 0, behavior: 'auto' });
    }

    list.querySelectorAll('.R-ContentList__item .u-whiteSpace--prewrap').forEach(addReadMore);
    updateButtons(list, prev, next);
  };

  const watch = (widget) => {
    let scheduled = false;
    const run = () => {
      scheduled = false;
      widget.querySelectorAll('.R-ContentList-container').forEach(enhance);
    };

    new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(run);
    }).observe(widget, { childList: true, subtree: true });

    run();
  };

  const init = () => document.querySelectorAll('.reviews-io-polaris-widget').forEach(watch);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
